import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  chooseInterestsAction,
  chooseAgeAction,
  chooseDiversityAction,
} from "features/application/form/redux/actions";

import InterestsView from "features/application/interests/view";

const mapDispatchToProps = (dispatch) => ({
  chooseInterests: (interests) => dispatch(chooseInterestsAction(interests)),
  chooseAge: (age) => dispatch(chooseAgeAction(age)),
  chooseDiversity: (diversity) => dispatch(chooseDiversityAction(diversity)),
});

class Interests extends Component {
  constructor(props) {
    super(props);

    this.interests = [];
    this.age = [];
    this.diversity = [];
    this.state = {
      errorAge: null,
      errorInterest: null,
      showDiversity: false,
      loadDiversity: false,
    };

    this.toggleCheck = this.toggleCheck.bind(this);
    this.sendApiRequest = this.sendApiRequest.bind(this);
    this.toggleClass = this.toggleClass.bind(this);
  }

  componentDidUpdate() {
    if (this.diversity.length > 0 && this.state.loadDiversity === false) {
      this.setState({
        loadDiversity: true,
        showDiversity: true,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { interests, age, diversity } = this.props;

    if (nextProps.interests && nextProps.interests !== interests) {
      for (let i = 0; i < nextProps.interests.length; i++) {
        nextProps.interests[i].is_selected &&
          this.interests.push(nextProps.interests[i].id);
      }
    }

    if (nextProps.age && nextProps.age !== age) {
      for (let i = 0; i < nextProps.age.length; i++) {
        nextProps.age[i].is_selected && this.age.push(nextProps.age[i].id);
      }
    }

    if (nextProps.diversity && nextProps.diversity !== diversity) {
      for (let i = 0; i < nextProps.diversity.length; i++) {
        nextProps.diversity[i].is_selected &&
          this.diversity.push(nextProps.diversity[i].id);
      }
    }
  }

  toggleCheck(event) {
    this.setState({
      errorAge: null,
      errorInterest: null,
    });

    if (event.target.className === "interests__item") {
      if (event.target.dataset.interest && this.interests.length < 15) {
        this.interests.push(parseInt(event.target.dataset.interest));

        event.target.className = "interests__item--checked";
      } else if (event.target.dataset.interest) {
        this.setState({
          errorInterest: parseInt(event.target.dataset.interest),
        });
      }

      if (event.target.dataset.age && this.age.length < 3) {
        this.age.push(parseInt(event.target.dataset.age));

        event.target.className = "interests__item--checked";
      } else if (event.target.dataset.age) {
        this.setState({ errorAge: parseInt(event.target.dataset.age) });
      }

      if (event.target.dataset.diversity) {
        this.diversity.push(parseInt(event.target.dataset.diversity));

        event.target.className = "interests__item--checked";
      }
    } else {
      event.target.className = "interests__item";

      event.target.dataset.interest &&
        (this.interests = this.interests.filter(
          (value) => value !== parseInt(event.target.dataset.interest)
        ));

      event.target.dataset.age &&
        (this.age = this.age.filter(
          (value) => value !== parseInt(event.target.dataset.age)
        ));

      event.target.dataset.diversity &&
        (this.diversity = this.diversity.filter(
          (value) => value !== parseInt(event.target.dataset.diversity)
        ));
    }
  }

  toggleClass(event) {
    if (
      event.target.dataset.diversitygroup &&
      this.state.showDiversity === false
    ) {
      this.setState({ showDiversity: true });
    } else if (
      event.target.dataset.diversitygroup &&
      this.state.showDiversity === true
    ) {
      this.diversity = [];
      this.setState({ showDiversity: false });
      const diversityElements = Array.from(
        document.querySelectorAll("[data-diversity]")
      );

      diversityElements.map((diversity) => {
        if (diversity.classList.contains("interests__item--checked")) {
          diversity.className = "interests__item";
        }
      });
    }
  }

  sendApiRequest() {
    const { chooseInterests, chooseAge /*chooseDiversity*/ } = this.props;

    if (this.interests.length && this.age.length) {
      chooseInterests(this.interests);
      chooseAge(this.age);
      // chooseDiversity(this.diversity);
    }
  }

  render() {
    const { interests, age, diversity, backToPreviousStep } = this.props;

    return (
      <InterestsView
        interests={interests}
        age={age}
        diversity={diversity}
        errorAge={this.state.errorAge}
        showDiversity={this.state.showDiversity}
        errorInterest={this.state.errorInterest}
        toggleCheck={this.toggleCheck}
        toggleClass={this.toggleClass}
        backToPreviousStep={backToPreviousStep}
        sendApiRequest={this.sendApiRequest}
      />
    );
  }
}

Interests.propTypes = {
  interests: PropTypes.array,
  age: PropTypes.array,
  diversity: PropTypes.array,
  backToPreviousStep: PropTypes.func,
  chooseInterests: PropTypes.func,
  chooseAge: PropTypes.func,
  chooseDiversity: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(Interests);
